import React, { useState, useEffect } from "react";
import { Col, Modal, ModalBody, ModalHeader, Row, Button } from "reactstrap";
import { BASE_URL } from "../../Config/AppConstant";
import { Tabs, Tab } from 'react-bootstrap';
import { LOCAL_URL } from "../../Config/AppConstant";
import axios from "axios";

const ViewModal = ({ viewModal, setViewModal, data }) => {
  const [activeTab, setActiveTab] = useState("personal");
  const [medicalRemainder, setMedicalRemainder] = useState([]);
  const [subscription, setSubscription] = useState([]);


  console.log("data::", data.status)

  const getMedicalReminder = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${LOCAL_URL}/medicalRemainders/${data._id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      console.log("Medical Remainder response::", response.data);
      setMedicalRemainder(response.data.data);
    } catch (error) {
      console.log("Error fetching medical reminders::", error);
    }
  };

  const getSubscription = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${LOCAL_URL}/fitness/subscription/vendor/user/${data._id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      console.log("Medical Remainder response::", response.data);
      setSubscription(response.data.data);
    } catch (error) {
      console.log("Error fetching medical reminders::", error);
    }
  };

  useEffect(() => {
    if (activeTab === "medicalRemainder") {
      getMedicalReminder();
    } else if (activeTab === 'subscription') {
      getSubscription();
    }
  }, [activeTab, data._id]);

  const labelStyle = {
    fontWeight: "bold",
    color: "#6c757d",
  };

  const valueStyle = {
    color: "#495057",
  };

  const profileImageStyle = {
    width: "100px",
    height: "100px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "2px solid #6c757d",
  };

  const handleModalClose = () => {
    setViewModal(false);
    setActiveTab("personal");
  };

  return (
    <Modal
      isOpen={viewModal}
      toggle={handleModalClose}
      size="lg"
      centered
      style={{ maxWidth: "50%" }}
    >
      <ModalHeader className="d-flex justify-content-between align-items-center">
        <span>View Details</span>
        <Button close onClick={handleModalClose} />
      </ModalHeader>
      <ModalBody style={{ maxHeight: "60vh", overflowY: "auto", padding: '20px' }}>
        <Tabs activeKey={activeTab} onSelect={(key) => setActiveTab(key)} id="profile-tabs" className="mb-3">
          <Tab eventKey="personal" title="Personal Info">
            <Row className="text-center mb-4">
              <Col>
                <img
                  src={data?.avatar ? `${BASE_URL}/uploads/${data.avatar}` : "https://via.placeholder.com/100"}
                  alt="Profile"
                  style={profileImageStyle}
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md="6" style={labelStyle}>Name:</Col>
              <Col md="6" style={valueStyle}>{data?.name || "N/A"}</Col>
            </Row>
            <Row className="mb-3">
              <Col md="6" style={labelStyle}>Email:</Col>
              <Col md="6" style={valueStyle}>{data?.email || "N/A"}</Col>
            </Row>
            <Row className="mb-3">
              <Col md="6" style={labelStyle}>Phone:</Col>
              <Col md="6" style={valueStyle}>{data?.phoneNumber || "N/A"}</Col>
            </Row>
            <Row className="mb-3">
              <Col md="6" style={labelStyle}>Address:</Col>
              <Col md="6" style={valueStyle}>{data?.address || "N/A"}</Col>
            </Row>
            <Row className="mb-3">
              <Col md="6" style={labelStyle}>Status:</Col>
              <Col md="6" style={valueStyle}>
                {data?.status ? (
                  <span className="badge bg-success">Active</span>
                ) : (
                  <span className="badge bg-danger">Blocked</span>
                )}
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md="6" style={labelStyle}>DOB:</Col>
              <Col md="6" style={valueStyle}>{data?.dob || "N/A"}</Col>
            </Row>
            <Row className="mb-3">
              <Col md="6" style={labelStyle}>Gender:</Col>
              <Col md="6" style={valueStyle}>{data?.gender || "N/A"}</Col>
            </Row>
          </Tab>

          <Tab eventKey="medicalRemainder" title="Medical Remainder">
            {medicalRemainder && medicalRemainder?.length > 0 ? (
              medicalRemainder.map((remainder, index) => (
                <>
                  <div key={index}>
                    <Row className="mb-3">
                      <Col md="6" style={labelStyle}>Medicine:</Col>
                      <Col md="6" style={valueStyle}>{remainder.medicine?.name || "N/A"}</Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="6" style={labelStyle}>Disease Type:</Col>
                      <Col md="6" style={valueStyle}>{remainder.disease?.diseaseType || "N/A"}</Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="6" style={labelStyle}>Disease Name:</Col>
                      <Col md="6" style={valueStyle}>{remainder.disease?.diseaseName || "N/A"}</Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="6" style={labelStyle}>Disease Duration:</Col>
                      <Col md="6" style={valueStyle}>{remainder.disease?.diseaseDuration || "N/A"}</Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="6" style={labelStyle}>Schedule Mode:</Col>
                      <Col md="6" style={valueStyle}>{remainder.scheduleMode || "N/A"}</Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="6" style={labelStyle}>Interval Days:</Col>
                      <Col md="6" style={valueStyle}>{remainder.intervalDays || "N/A"}</Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="6" style={labelStyle}>Start Date:</Col>
                      <Col md="6" style={valueStyle}>{new Date(remainder.startDate).toLocaleDateString() || "N/A"}</Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md="6" style={labelStyle}>Schedule Timings:</Col>
                      <Col md="6" style={valueStyle}>
                        {remainder.scheduleTimings?.map((timing, idx) => (
                          <>
                            {timing.day}: {timing.time} {timing.dosage ? `, Dosage: ${timing.dosage}` : ""}
                            <br />
                          </>
                        ))}
                      </Col>
                    </Row>
                  </div>
                  <hr />
                </>
              ))
            ) : (
              <p>No medical reminders available</p>
            )}
          </Tab>

          <Tab eventKey={'subscription'} title="Subscription">
            {subscription && subscription.length > 0 ? (
              subscription.map((sub, index) => (
                <div key={index}>
                  <Row className="mb-3">
                    <Col md="6" style={labelStyle}>Start Date:</Col>
                    <Col md="6" style={valueStyle}>{sub.startDate ? new Date(sub.startDate).toLocaleDateString() : "N/A"}</Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md="6" style={labelStyle}>End Date:</Col>
                    <Col md="6" style={valueStyle}>{sub.endDate ? new Date(sub.endDate).toLocaleDateString() : "N/A"}</Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md="6" style={labelStyle}>Label:</Col>
                    <Col md="6" style={valueStyle}>{sub.label || "N/A"}</Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md="6" style={labelStyle}>Status:</Col>
                    <Col md="6" style={valueStyle}>{sub.status || "N/A"}</Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md="6" style={labelStyle}>Fitness Goal:</Col>
                    <Col md="6" style={valueStyle}>{sub.fitnessGoal || "N/A"}</Col>
                  </Row>
                </div>
              ))
            ) : (
              <p>No subscription data found</p>
            )}
          </Tab>
        </Tabs>
      </ModalBody>
    </Modal >
  );
};

export default ViewModal;
